"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFloraThemeByBrand = exports.brandThemes = void 0;
const flora_1 = require("@grupoboticario/flora");
const envConfig_1 = require("./helpers/config/envConfig");
var FloraThemeBrand;
(function (FloraThemeBrand) {
    FloraThemeBrand["BOT"] = "BOT";
    FloraThemeBrand["EUD"] = "EUD";
    FloraThemeBrand["OUI"] = "OUI";
    FloraThemeBrand["EAM"] = "EAM";
    FloraThemeBrand["GB"] = "GB";
    FloraThemeBrand["MLT"] = "MLT";
})(FloraThemeBrand || (FloraThemeBrand = {}));
exports.brandThemes = {
    [FloraThemeBrand.BOT]: flora_1.boticarioTheme,
    [FloraThemeBrand.EUD]: flora_1.eudoraTheme,
    [FloraThemeBrand.OUI]: flora_1.ouiTheme,
    [FloraThemeBrand.EAM]: flora_1.quemDisseBereniceTheme,
    [FloraThemeBrand.GB]: flora_1.gbInstitucionalTheme,
    [FloraThemeBrand.MLT]: flora_1.gbInstitucionalTheme,
};
const getFloraThemeByBrand = () => {
    var _a;
    const currentBrand = (((_a = envConfig_1.envConfig.currentBrand) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || 'GB');
    return exports.brandThemes[currentBrand];
};
exports.getFloraThemeByBrand = getFloraThemeByBrand;
